export const VERSION = "v4.36.0";
